import { createAction } from '@reduxjs/toolkit'

import type {
  AddMessagePayload,
  AIChatErrorType,
  AIChatMessageUI,
  InitGenerationPayload,
  SendMessagePayload,
  SetCancelTokenPayload,
  StartChatPayload,
} from './types'
import type { ChatAgentStatus } from './v2/types'

export const AIExternalActions = {
  startChat: createAction<StartChatPayload>('AI_START_CHAT_SAGA'),
  sendMessage: createAction<SendMessagePayload>('AI_SEND_MESSAGE_SAGA'),
  stopMessage: createAction('AI_STOP_MESSAGE_SAGA'),
  addMessage: createAction<AddMessagePayload>('AI_ADD_MESSAGE'),
}

export const AIInternalActions = {
  initGeneration: createAction<InitGenerationPayload>('AI_INIT_GENERATION'),
  resetGeneration: createAction('AI_RESET_GENERATION'),
  setGenerating: createAction<boolean>('AI_SET_GENERATING'),
  setHistoryLoading: createAction<boolean>('AI_SET_HISTORY_LOADING'),
  setError: createAction<AIChatErrorType | null>('AI_SET_ERROR'),
  setMessages: createAction<AIChatMessageUI[]>('AI_SET_MESSAGES'),
  updateRemainingRequests: createAction<number>('AI_UPDATE_REMAINING_REQUESTS'),
  removeLastMessage: createAction('AI_REMOVE_LAST_MESSAGE'),
  setCancelToken: createAction<SetCancelTokenPayload>('AI_SET_CANCEL_TOKEN'),

  // v2 (chat-agent) streaming actions. Dispatched only by the v2 sagas, so
  // the v1 path is unaffected while the feature flag is off.
  startStream: createAction('AI_START_STREAM'),
  setSessionId: createAction<string>('AI_SET_SESSION_ID'),
  appendStreamText: createAction<string>('AI_APPEND_STREAM_TEXT'),
  setAgentStep: createAction<string | null>('AI_SET_AGENT_STEP'),
  setAgentStatus: createAction<ChatAgentStatus | null>('AI_SET_AGENT_STATUS'),
  commitStreamedMessage: createAction('AI_COMMIT_STREAMED_MESSAGE'),
  resetStream: createAction('AI_RESET_STREAM'),
  setLastSentMessage: createAction<string | null>('AI_SET_LAST_SENT_MESSAGE'),
}

export const AIActions = {
  ...AIExternalActions,
  ...AIInternalActions,
}
